// extracted by mini-css-extract-plugin
module.exports =  {"input":"inputNumber__input","input-wrapper":"inputNumber__input-wrapper","control":"inputNumber__control","control-button":"inputNumber__control-button"};